import React, { Suspense, useEffect } from "react";

import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Row,
} from "reactstrap";
import {
  Input,
  Divider,
  Form,
  Switch,
  Modal,
  Select,
  InputNumber,
  Radio,
  Checkbox,
  Button as ANTButton
} from "antd";
import { Link, Redirect, Route } from "react-router-dom";
import "./Register.scss";
import { useSelector } from "react-redux";
// import SelectLang from "../../SelectLanguage/SelectLang";
import { useState } from "react";
import { UserOutlined, LockOutlined, TeamOutlined } from "@ant-design/icons";
import SelectLang from "../../Components/SelectLanguage/SelectLang";
import axios from "axios";
import { baseUrl } from "../../Controllers/rest_api_config";
import { error, success, warning } from "../../Controllers/toast";
import MobileValidation from "../Login/mobileValidation";
import { gql, useMutation } from "@apollo/client";
import { HashingPassword } from "../../Controllers/passwordHasher";
import TepayaLogo from "../../Assets/img/brand/logo.svg";
// import solarImg from '../../../../public/assets/img/solar-panel-login.jpg';
const layout = {
  labelCol: {
    span: 12,
  },
  wrapperCol: {
    span: 24,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 0,
    span: 24,
  },
};

const REGISTER = gql`
  mutation RegisterInput(
    $firstname: String!
    $lastname: String!
    $email: String!
    $mobile: String!
    $password: String!
    $contractor: Boolean
    $coname: String
    $website: String
    $country: String
    $city: String
    $address: String
    $postcode: String
    $cotel: String
  ) {
    Register(
      registerInput: {
        firstname: $firstname
        lastname: $lastname
        email: $email
        mobile: $mobile
        password: $password
        contractor: $contractor
        coname: $coname
        website: $website
        country: $country
        city: $city
        address: $address
        postcode: $postcode
        cotel: $cotel
      }
    ) {
      user_id
      firstname
      lastname
      email
      mobile
      role
    }
  }
`;

const Register = () => {
  const lang_choiced = useSelector((state) => state.lang_change);
  const [form] = Form.useForm();
  const [checkBox, setCheckbox] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visiblePrivacy, setVisiblePrivacy] = useState(true);
  const [visibleModal, setVisibleModal] = useState(false);
  const [formData, setFormData] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [handleCancelModal, setHandleCancelModal] = useState(false);
  const [userRegister, { loading }] = useMutation(REGISTER, {
    onCompleted: (res) => {
      // console.log(res);
      if (res.Register.user_id) {
        success("شما با موفقیت ثبت نام شدید!");
        form.resetFields();
        setVisibleModal(false);
        setCheckbox(false);
        setTimeout(() => {
          window.location.replace("/#/login");
        }, 1000);
      } else {
        error("مشکلی رخ داده است!");
      }
    },
    onError: (err) => {
      // console.log(err.message);
      error(err.message);
      setVisibleModal(false);
    },
  });
  // const dispatch = useDispatch();

  const onFinish = (value) => {
    // console.log(value);
    setVisibleModal(true);
    setFormData(value);
    // value = {value , contractor:checkBox}
  };
  const handleFinish =async (value) => {
    if (value.password === value.rePassword) {
      // console.log(value.password,await HashingPassword(value.password))
      userRegister({
        variables: {
          firstname: value.firstname,
          lastname: value.lastname,
          email: value.email,
          mobile: value.mobile,
          password:await HashingPassword(value.password),
          contractor: value.contractor,

          coname: value.coname || "",
          website: value.website || "",
          country: value.country || "",
          city: value.city || "",
          address: value.address || "",
          postcode: value.postcode || "",
          cotel: value.cotel || "",
        },
      });
      
      // console.log("The result of form value is : ", value);
      // axios
      //   .post(
      //     `${baseUrl}/auth/register`,
      //     {},
      //     { headers: { "Content-Type": "json" }, params: value }
      //   )
      //   .then((res) => {
      //     console.log(res, "is response from register");
      //     if (res.data.status === "success") {
      //       form.resetFields();
      //       setVisibleModal(false);
      //       setCheckbox(false);
      //       success(res.data.text);
      //       setTimeout(() => {
      //         window.location.replace("/#/login");
      //       }, 1000);
      //     }
      //   })
      //   .catch((err) => {
      //     if (err.response.data) {
      //       error(err.response.data.text);
      //       setHandleCancelModal(true);
      //     } else {
      //       error("مشکلی رخ داده است!");
      //     }
      //   });
    } else {
      error("تکرار رمز عبور نادرست است !");
    }
  };
  const onFinishFailed = (err) => {
    // console.log(err);
    warning("لطفا اطلاعات را بدرستی وارد کنید!")
  };
  const toggleCheckBox = () => {
    setVisible(!checkBox);
    setCheckbox(!checkBox);
    // console.log(checkBox , 'is check box');
  };

  // Set Mobile Code Token in LocalStorage

  // if (window.localStorage.getItem("m_t_s")) {
    return (
      <div
        className="app flex-row align-items-center login-background"
        style={{ height: "auto", padding: " 25px" }}
      >
        <Container>
          <MobileValidation
            handleCancelModal={handleCancelModal}
            setHandleCancelModal={(value) => setHandleCancelModal(value)}
            setMobile={(phone) => {
              setPhoneNumber(phone);
            }}
            setVisible={(value) => setVisibleModal(value)}
            visible={visibleModal}
            setResponse={(value) =>
              value === true
                ? handleFinish({ ...formData, mobile: phoneNumber })
                : ""
            }
            register
          />
          <Row className="justify-content-center" style={{}}>
            <Col sm="8" xl="6" md="8">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                  <Row>
                      <Col
                        className="text-center"
                        md={12}
                        xs={12}
                        sm={12}
                        lg={12}
                      >
                        <div>
                          <img src={TepayaLogo} width={72} />
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={8} xs={8} sm={8} lg={8}>
                        <span className="h2">
                          {lang_choiced.pages.register.title}
                        </span>
                      </Col>
                      <Col md={4} xs={4} sm={4} lg={4}>
                        <SelectLang
                          className="lang-style text-right"
                          style={{ width: "16px" }}
                        />
                      </Col>
                    </Row>
                    {/* <Divider style={{ backgroundColor: "black" }} /> */}
                    <Form
                      form={form}
                      name="register"
                      initialValues={{
                        contractor: false,
                        privacy: false,
                        mag: false,
                      }}
                      {...layout}
                      onFinish={onFinish}
                      onFinishFailed={onFinishFailed}
                      // labelCol={{span:24 , offset:17 , }}
                      // labelAlign="left"
                      layout="vertical"
                    >
                      <Form.Item
                        {...tailLayout}
                        label={
                          <span>
                            <TeamOutlined className="Icon-style" />
                            {lang_choiced.pages.register.forms.firstname}
                          </span>
                        }
                        name="firstname"
                        rules={[
                          {
                            required: true,
                            message: lang_choiced.pages.register.rules.firstname,
                          },
                        ]}
                      >
                        <Input
                          className="login-form-style "
                          size="large"
                          type="text"
                        />
                      </Form.Item>
                      <Form.Item
                        {...tailLayout}
                        label={
                          <span>
                            <TeamOutlined className="Icon-style" />
                            { lang_choiced.pages.register.forms.lastname}
                          </span>
                        }
                        name="lastname"
                        rules={[
                          {
                            required: true,
                            message:  lang_choiced.pages.register.rules.lastname,
                          },
                        ]}
                      >
                        <Input
                          className="login-form-style "
                          size="large"
                          type="text"
                        />
                      </Form.Item>
                      <Form.Item
                        {...tailLayout}
                        label={
                          <span>
                            <UserOutlined className="Icon-style " />
                            { lang_choiced.pages.register.forms.email}
                          </span>
                        }
                        name="email"
                        rules={[
                          {
                            type: "email",
                            message:  lang_choiced.pages.register.rules.correctEmailPattern,
                          },
                          {
                            required: true,
                            message:  lang_choiced.pages.register.rules.email,
                          },
                        ]}
                      >
                        <Input
                          className="login-form-style input-ltr"
                          size="large"
                          autoComplete="email"
                          type="text"
                        />
                      </Form.Item>
                      <Form.Item
                        {...tailLayout}
                        label={
                          <span>
                            <LockOutlined className="Icon-style" />
                            { lang_choiced.pages.register.forms.password}
                          </span>
                        }
                        name="password"
                        rules={[
                          {
                            required: true,
                            message:lang_choiced.pages.register.rules.password ,
                          },
                        ]}
                      >
                        <Input
                          className="login-form-style input-ltr"
                          size="large"
                          autoComplete="current-password"
                          type="password"
                        />
                      </Form.Item>
                      <Form.Item
                        {...tailLayout}
                        label={
                          <span>
                            <LockOutlined className="Icon-style" />
                           {lang_choiced.pages.register.forms.rePassword}
                          </span>
                        }
                        name="rePassword"
                        rules={[
                          {
                            required: true,
                            message: lang_choiced.pages.register.rules.password,
                          },
                        ]}
                      >
                        <Input
                          className="login-form-style input-ltr"
                          size="large"
                          autoComplete="current-password"
                          type="password"
                        />
                      </Form.Item>
                      <Form.Item
                        {...tailLayout}
                        name="contractor"
                        valuePropName="checked"
                      >
                        <Checkbox onChange={toggleCheckBox}>
                          {lang_choiced.pages.register.forms.contractor}
                        </Checkbox>
                      </Form.Item>
                      {visible === true && checkBox === true ? (
                        <div>
                          <Form.Item
                            {...tailLayout}
                            label={
                              <span>
                                <TeamOutlined className="Icon-style" />
                                {lang_choiced.pages.register.forms.coname}
                              </span>
                            }
                            name="coname"
                            rules={[
                              {
                                required: true,
                                message: lang_choiced.pages.register.rules.coname,
                              },
                            ]}
                          >
                            <Input
                              className="login-form-style "
                              size="large"
                              type="text"
                            />
                          </Form.Item>
                          <Form.Item
                            {...tailLayout}
                            name="website"
                            label={
                              <span>
                                <TeamOutlined className="Icon-style" />
                                {lang_choiced.pages.register.forms.website}
                              </span>
                            }
                          >
                            <Input
                              className="login-form-style input-ltr"
                              size="large"
                              type="url"
                            />
                          </Form.Item>
                          <Form.Item
                            {...tailLayout}
                            label={
                              <span>
                                <TeamOutlined className="Icon-style" />
                                {lang_choiced.pages.register.forms.country}
                              </span>
                            }
                            name="country"
                            rules={[
                              {
                                required: true,
                                message: lang_choiced.pages.register.rules.country,
                              },
                            ]}
                          >
                            <Input
                              className="login-form-style "
                              size="large"
                              type="text"
                            />
                          </Form.Item>
                          <Form.Item
                            {...tailLayout}
                            label={
                              <span>
                                <TeamOutlined className="Icon-style" />
                               {lang_choiced.pages.register.forms.city}
                              </span>
                            }
                            name="city"
                            rules={[
                              {
                                required: true,
                                message:lang_choiced.pages.register.rules.city,
                              },
                            ]}
                          >
                            <Input
                              className="login-form-style "
                              size="large"
                              type="text"
                            />
                          </Form.Item>
                          <Form.Item
                            {...tailLayout}
                            label={
                              <span>
                                <TeamOutlined className="Icon-style" />
                               {lang_choiced.pages.register.forms.address}
                              </span>
                            }
                            name="address"
                            rules={[
                              {
                                required: true,
                                message: lang_choiced.pages.register.rules.address,
                              },
                            ]}
                          >
                            <Input
                              className="login-form-style "
                              size="large"
                              type="text"
                            />
                          </Form.Item>
                          <Form.Item
                            {...tailLayout}
                            label={
                              <span>
                                <TeamOutlined className="Icon-style" />
                                {lang_choiced.pages.register.forms.postcode}
                              </span>
                            }
                            name="postcode"
                            rules={[
                              {
                                required: true,
                                message:lang_choiced.pages.register.rules.postcode ,
                              },
                            ]}
                          >
                            <Input
                              className="login-form-style "
                              size="large"
                              type="number"
                            />
                          </Form.Item>
                          <Form.Item
                            {...tailLayout}
                            label={
                              <span>
                                <TeamOutlined className="Icon-style" />
                               {lang_choiced.pages.register.forms.cotel}
                              </span>
                            }
                            name="cotel"
                            rules={[
                              {
                                required: true,
                                message: lang_choiced.pages.register.rules.cotel,
                              },
                            ]}
                          >
                            <Input
                              className="login-form-style "
                              size="large"
                              type="text"
                            />
                          </Form.Item>
                        </div>
                      ) : (
                        ""
                      )}
                      {/* <div>Captcha code</div> */}
                      <Form.Item
                        {...tailLayout}
                        name="privacy"
                        valuePropName="checked"
                        rules={[
                          {
                            required: true,
                            message: lang_choiced.pages.register.rules.acceptRules,
                          },
                        ]}
                      >
                        <Checkbox
                          onChange={() => setVisiblePrivacy(!visiblePrivacy)}
                          style={{ color: "red" }}
                        >
                          {lang_choiced.pages.register.forms.policy}
                        </Checkbox>
                      </Form.Item>
                      <Form.Item
                        {...tailLayout}
                        name="mag"
                        valuePropName="checked"
                      >
                        <Checkbox> {lang_choiced.pages.register.forms.news}</Checkbox>
                      </Form.Item>

                      <Form.Item>
                        <Row style={{ textAlign: "center" }}>
                          <Col sm={12} xs={12} md={12} lg={12} xl={12}>
                            <Button
                              disabled={visiblePrivacy}
                              color="danger"
                              className=" login-button"
                              // htmlType="submit"
                            >
                               {lang_choiced.pages.register.forms.btnRegister}
                            </Button>
                          </Col>
                        </Row>
                      </Form.Item>
                      
                      </Form>
                      <Divider />
                    <Row style={{ textAlign: "center" }}>
                        <Col sm={12} xs={12} md={12} lg={12} xl={12}>
                          <Link to="/">
                            <ANTButton
                              type="link"
                              onClick={() => {
                                // showModal("register")
                              }}
                            >
                              {lang_choiced.pages.register.forms.btnLogin}
                            </ANTButton>
                          </Link>
                          
                        </Col>
                      </Row>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  // } else {
  //   return <Redirect to="/login" />;
  // }
};

export default Register;
